import React from 'react';
import styled from 'styled-components';
import { T2, B1, Text32 } from '@nile/components';
import { Link, Button } from '@superops/ui-design-system';
import { FormattedMessage } from 'react-intl';

const ErrorPageContent = styled.div`
  display: flex;
  .text {
    line-height: 60px;
  }
  .description {
    max-width: 400px;
    padding-right: 80px;
  }
`;

const ErrorPageWrapper = styled.div`
  height: ${(props) => (props.inheritHeight ? '100%' : '100vh')};
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .jc-ctr {
    justify-content: center;
  }
`;

const Image = styled.div`
  background-image: ${(props) => props.url};
  background-size: 100%;
  background-repeat: no-repeat;
  height: ${(props) => props.height || '170px'};
  width: ${(props) => props.width || '200px'};
`;

const linkMap = {
  '#/updatenewpassword': 'update password',
  '#/configurenewtfa': 'configure TFA',
  '#/pricing': 'purchase plan',
  '#/buyplans': 'purchase plan'
};

const ErrorPage = (props) => {
  const {
    imageURL,
    text,
    description,
    height,
    width,
    link,
    showBtn,
    inheritHeight = false,
    showRefreshBtn = false,
    linkExternal
  } = props;

  return (
    <ErrorPageWrapper inheritHeight={inheritHeight}>
      <div className="errorContainer">
        <ErrorPageContent>
          <div className="flex col jc-ctr">
            {text && (
              <Text32 className="text">
                <B1>{text}</B1>
              </Text32>
            )}
            {description && <T2 className="description">{description}</T2>}
            {showRefreshBtn && (
              <div className="mt-20 flex gap-10">
                <div className="ptr" onClick={() => window.location.reload()}>
                  Refresh
                </div>
                <div>
                  <Link url="#/home" removeUnderline>
                    Home
                  </Link>
                </div>
              </div>
            )}
          </div>
          <Image url={imageURL} height={height} width={width} />
        </ErrorPageContent>
        {link && (
          <div className="mt-20">
            Click <Link url={link}>here</Link> to {linkMap[link]}
          </div>
        )}
        {linkExternal && (
          <div className="mt-20">
            Click
            <Link url={linkExternal} external>
              here
            </Link>
            to contact support
          </div>
        )}
        {showBtn && (
          <div className="mt-20">
            <Button plain onClick={() => window.Intercom('show')}>
              <FormattedMessage id="admin.billing.contactsupport" />
            </Button>
          </div>
        )}
      </div>
    </ErrorPageWrapper>
  );
};

export default ErrorPage;
